import React from "react";
import { Paper, Grid } from "@mui/material";
import CreatePassengerSelectAge from "./CreatePassengerSelectAge";
import CreatePassengerItem from "./CreatePassengerItem";
import CreatePassengerSeats from "./CreatePassengerSeats";

const PassengerSection = ({
  isReturn = false,
  ages,
  setAges,
  setReturnAges,
  passengers,
  setPassengers,
  returnPassengers,
  setReturnPassengers,
  seats,
  returnSeats,
  setSeats,
  setReturnSeats,
  handlePassengerUpdate,
  handleDeletePassengerFromList,
}) => {
  const visiblePassengers = isReturn ? returnPassengers : passengers;
  const visibleSetPassengers = isReturn ? setReturnPassengers : setPassengers;
  const visibleSetAges = isReturn ? setReturnAges : setAges;
  const visibleSeats = isReturn ? returnSeats || seats : seats;
  const visibleSetSeats = isReturn ? setReturnSeats || setSeats : setSeats;
  const normalizedSeats = visibleSeats || { large: 0, medium: 0, small: 0 };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        borderRadius: 3,
        mb: 2,
        backgroundColor: "#f9fafb",
        width: "100%",
        boxShadow: "none",
      }}
    >
      <CreatePassengerSelectAge
        isReturn={isReturn}
        ages={ages}
        setAges={setAges}
        setReturnAges={setReturnAges}
        passengers={passengers}
        setPassengers={setPassengers}
        returnPassengers={returnPassengers}
        setReturnPassengers={setReturnPassengers}
        sourcePassengers={isReturn ? passengers : []}
      />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        {visiblePassengers.map((passenger, index) => (
          <Grid item xs={12} key={index}>
            <CreatePassengerItem
              index={index}
              name={passenger.name}
              address={passenger.address}
              flight={passenger.flight}
              contactTel={passenger.contactTel}
              passengersState={visiblePassengers}
              setAgesState={visibleSetAges}
              setPassengersState={visibleSetPassengers}
              setState={visibleSetPassengers}
              age={passenger.age}
              onUpdate={handlePassengerUpdate}
              onDelete={handleDeletePassengerFromList}
            />
          </Grid>
        ))}
      </Grid>

      {(ages.baby > 0 || ages.child > 0) && (
        <CreatePassengerSeats
          isReturn={isReturn}
          seats={normalizedSeats}
          setSeats={visibleSetSeats}
          setReturnSeats={setReturnSeats}
        />
      )}
    </Paper>
  );
};

export default PassengerSection;
